export const MANULIFE_DATE_OF_BIRTH = 'manulife-date-of-birth';